<h1 mat-dialog-title>Forgot Password</h1>
<div mat-dialog-content>
  Please contact Help Desk for assistance in resetting your password
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button cdkFocusInitial (click)="onNoClick()" color="primary">Ok</button>
</div>